import * as z from "zod/v4";

export const investmentCalculatorAccessFormSchema = z.object({
	email: z.email(),
	firstName: z.string().min(1),
	lastName: z.string().min(1),
	phone: z
		.string()
		.regex(/^\(\d{3}\) \d{3}-\d{4}$/, "Please enter a valid 10-digit phone number"),
	pageUri: z.string(),
	pageName: z.string(),
	turnstileToken: z.string()
});

export type InvestmentCalculatorAccessFormSchema = z.infer<
	typeof investmentCalculatorAccessFormSchema
>;

export const investmentCalculatorAccessFormClientSchema = investmentCalculatorAccessFormSchema.pick(
	{
		email: true,
		firstName: true,
		lastName: true,
		phone: true,
		turnstileToken: true
	}
);
